<script lang="ts">
    import { isDarkTheme } from "../../../store";
    export let number;
    export let placeholder;
</script>

<input
    class="font-family-bardic-sans font-size-2-rem text-align-center"
    class:darker-background={$isDarkTheme}
    bind:value={number}
    type="number"
    placeholder={placeholder}
/>
